'use client';

import React, { memo, useMemo } from 'react';

interface AppLogoProps {
  size?: number;
  className?: string;
  onClick?: () => void;
  showText?: boolean;
}

const AppLogo = memo(function AppLogo({
  size = 32,
  className = '',
  onClick,
  showText = false,
}: AppLogoProps) {
  const containerClassName = useMemo(() => {
    const classes = ['flex items-center gap-2'];
    if (onClick) classes.push('cursor-pointer hover:opacity-80 transition-opacity');
    if (className) classes.push(className);
    return classes.join(' ');
  }, [onClick, className]);

  // Scale SVG proportionally to container size
  const svgSize = Math.round(size * 0.56); // ~18px at size 32

  return (
    <div className={containerClassName} onClick={onClick}>
      {/* Green rounded-square mark with an upward zigzag — design_handoff_showmetrade */}
      <div
        className="flex items-center justify-center flex-shrink-0"
        style={{
          width: size,
          height: size,
          borderRadius: Math.round(size * 0.3),
          backgroundColor: 'var(--accent, #0C5B41)',
        }}
      >
        <svg
          width={svgSize}
          height={svgSize}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <polyline points="2,15 7,9 11,12 18,4" stroke="#F6F4EE" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          <polyline points="13,4 18,4 18,9" stroke="#F6F4EE" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>

      {/* Logo text: ShowMe(ink) Trade(accent) — matches Navbar's wordmark */}
      {showText && (
        <span className="text-base font-extrabold tracking-tight whitespace-nowrap" style={{ fontFamily: "'Bricolage Grotesque', sans-serif" }}>
          <span style={{ color: 'var(--text-primary, #1C2B26)' }}>ShowMe</span>
          <span style={{ color: 'var(--accent, #0C5B41)' }}>Trade</span>
        </span>
      )}
    </div>
  );
});

AppLogo.displayName = 'AppLogo';

export default AppLogo;
